import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles37 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial37/tutorial37.zip?ref_type=heads&inline=false', download: 'tutorial37.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtySeven= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Embed OpenCV Camera Into Qt Designer Form with PyQt6 And Python</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/hdb7x-epEpk/maxresdefault.jpg"
                            alt="Tutorial 37"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this PyQt6 tutorial, you'll learn how to seamlessly embed an OpenCV camera feed into a custom GUI designed with Qt Designer. This step-by-step guide will walk you through integrating a live video stream into your PyQt6 application, enhancing your GUI with real-time video processing capabilities.

                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Setting up PyQt6 and Qt Designer for video integration</li>
                            <li>Embedding OpenCV video feed into a QLabel</li>

                            <li>Connecting OpenCV with PyQt6 for smooth and real-time video processing</li>

                            <li>Handling GUI updates and events efficiently for a responsive user experience</li>
                        </ul>

                        Whether you're working on computer vision projects or interactive applications, this tutorial will help you bridge OpenCV and PyQt6 effectively.
                        <br /><br />
                        #PyQt6 #OpenCV #QtDesigner #Python3 #CameraIntegration #ComputerVision #GUI #RealTimeVideo #PythonDevelopment

                    </p>

                    <button className="seemore">
                        <DownloadFiles37 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtySeven;
